import React from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import useFilterMeta from "../hooks/use-filter-meta";
import useWillConstrain from "../hooks/use-will-constrain";

function OrderFilter(props) {

    const name = props.name;
    const sortable = props.sortable || name;

    let defaultDirection = useFilterMeta(name, sortable);

    const sortablesDefaultValueRef = React.useRef([]);

    let sortables = useFilterMeta(name, 'sortables', sortablesDefaultValueRef.current);

    const [direction, setDirection] = React.useState(defaultDirection);
    const [value, setValue] = React.useState({[sortable]: direction});

    const shouldConstrainCheck = React.useRef((value) => value && !!value[sortable]);

    useWillConstrain(name, value, shouldConstrainCheck.current);

    React.useEffect(() => {
        if(!direction) {
            return;
        }
        setValue({[sortable]: direction});
    }, [direction]);

    let template = props.children || <button>{direction}</button>;

    const shouldRender = !!sortable && sortables.includes(sortable);

    if (shouldRender === false) {
        return template;
    }

    const templateClassName = (template && template.props) ? template.props.className : null;

    if (typeof template === 'string') {
        template = <div>{template}</div>
    }

    const handleOnClick = () => {
        const currentDirection = direction || defaultDirection;
        const nextDirection = (currentDirection === 'asc') ? 'desc' : 'asc';
        setDirection(nextDirection);
    }

    return React.cloneElement(template, {
        onClick: handleOnClick,
        className: [templateClassName, 'sortable', direction].filter(e => e).join(' '),
    });
}

OrderFilter.defaultProps = {
    className: '',
    name: 'sort',
    defaultDirection: 'desc',
    sortable: null,
};

OrderFilter.propTypes = {
    className: PropTypes.string,
    defaultDirection: PropTypes.string,
    name: PropTypes.string,
    sortable: PropTypes.string,
};

export default observer(OrderFilter);
